/**
 * use-landing-products — 投放产品 API（ADM-LP-S001）
 *
 * 契约：dev-docs `02-API契约/AE-投放落地页.md` §1。全局模块，不传 `app_id`。
 * logo 上传通道不在本期（S001 plan NOT-in-scope，随 S003）。
 */

import type {
  CreateLandingProductRequest,
  LandingProductDto,
  UpdateLandingProductRequest,
} from '@novel-admin/shared';
import { type OffsetPagedResult, apiRequest, apiRequestOffsetPaged } from '~/api/client';

export const landingProductsApi = {
  list: (page: number, limit: number): Promise<OffsetPagedResult<LandingProductDto>> =>
    apiRequestOffsetPaged<LandingProductDto>({
      method: 'GET',
      path: '/api/v1/landing-products',
      query: { page, limit },
    }),
  get: (id: string): Promise<LandingProductDto> =>
    apiRequest<LandingProductDto>({ method: 'GET', path: `/api/v1/landing-products/${id}` }),
  create: (body: CreateLandingProductRequest): Promise<LandingProductDto> =>
    apiRequest<LandingProductDto>({ method: 'POST', path: '/api/v1/landing-products', body }),
  update: (id: string, body: UpdateLandingProductRequest): Promise<LandingProductDto> =>
    apiRequest<LandingProductDto>({
      method: 'PATCH',
      path: `/api/v1/landing-products/${id}`,
      body,
    }),
};
